import React from 'react';
import { formatPercent } from '../utils/formatters';
import { buildDisplayNameMap } from '../../../utils/portfolioNames';

const COLOURS = {
  primary: '#072040',
  success: '#91CF9B',
  info: '#599BE3',
  light: '#E7E6E6',
};

const PortfolioAllocationSummary = ({ weights, yieldRate, growthExposure, expectedReturn, volatility, portfolioRegistry }) => {
  if (!weights || Object.keys(weights).length === 0) return null;

  const nameMap = buildDisplayNameMap(portfolioRegistry);
  const displayName = (code) => nameMap[code] || code;
  const entries = Object.entries(weights);
  const totalWeight = entries.reduce((sum, [, w]) => sum + w, 0);

  return (
    <div className="card mb-4" style={{ borderTop: 'none' }}>
      <div className="card-header allocation-summary-header">
        <h6 className="mb-0">
          <i className="bi bi-pie-chart me-2"></i>Your Portfolio Allocation
        </h6>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <table className="table table-sm table-striped mb-0">
              <thead>
                <tr>
                  <th>Portfolio</th>
                  <th className="text-end">Allocation</th>
                </tr>
              </thead>
              <tbody>
                {entries.map(([name, weight]) => (
                  <tr key={name}>
                    <td>{displayName(name)}</td>
                    <td className="text-end">{formatPercent(weight)}</td>
                  </tr>
                ))}
                <tr style={{ borderTop: `2px solid ${COLOURS.primary}` }}>
                  <td className="fw-bold">Total</td>
                  <td className="text-end fw-bold">{formatPercent(totalWeight)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-md-6">
            <div className="d-flex justify-content-around align-items-center h-100">
              <div className="text-center">
                <div className="portfolio-metric-value" style={{ color: COLOURS.primary }}>
                  {growthExposure != null ? formatPercent(growthExposure) : '-'}
                </div>
                <small className="metric-label">Growth Exposure</small>
              </div>
              <div className="text-center">
                <div className="portfolio-metric-value" style={{ color: COLOURS.success }}>
                  {expectedReturn != null ? formatPercent(expectedReturn) : '-'}
                </div>
                <small className="metric-label">Expected Return</small>
              </div>
              <div className="text-center">
                <div className="portfolio-metric-value" style={{ color: COLOURS.info }}>
                  {volatility != null ? formatPercent(volatility) : '-'}
                </div>
                <small className="metric-label">Volatility</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioAllocationSummary;
